import React, { useState, useEffect } from 'react';
import Home from './components/Home';
import Career from './components/Career';
import Skills from './components/Skills';
import Achievements from './components/Achievements';
import Projects from './components/Projects';
import Contact from './components/Contact';
import BackToTop from './components/BackToTop';
import Navbar from './components/Navbar';
import Preloader from './components/Preloader';
import './styles/App.css';
import './styles/stars.css';

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a delay for testing the preloader
    const timer = setTimeout(() => {
      setLoading(false);
    }); // 3 seconds delay

    return () => clearTimeout(timer);
  }, []);

  const handleLoaded = () => {
    setLoading(false);
  };

  return (
    <div id="App" className="all background">
      {loading && <Preloader onLoaded={handleLoaded} />}
      {!loading && (
        <>
          <Navbar />
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>
          <section id="home">
            <Home />
          </section>
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>
          <section id="projects">
            <Projects />
          </section>
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>
          <section id="career">
            <Career />
          </section>
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>
          <section id="skills">

            <Skills />
          </section>
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>
          <section id="achievements">
            <Achievements />
          </section>
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>
          <section id="contact">
            <Contact />
          </section>
          <BackToTop />
        </>
      )}
    </div>
  );
};

export default App;